import { render, staticRenderFns } from "./NominationList.vue?vue&type=template&id=4302bc62&scoped=true"
import script from "./NominationList.vue?vue&type=script&lang=js"
export * from "./NominationList.vue?vue&type=script&lang=js"
import style0 from "./NominationList.vue?vue&type=style&index=0&id=4302bc62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4302bc62",
  null
  
)

export default component.exports